import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular/main';
import { ICellRendererParams } from 'ag-grid-community/main';
import { Params } from '@angular/router';

export interface BarParams {
    appendLink?: boolean;
    routerLink?: any[];
    queryParams?: Params;
    value: number;
    threshold: number;
}

@Component({
    selector: 'bar-cell',
    template: require('./bar-renderer.component.html'),
    styles: [require('./bar-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BarRendererComponent implements AgFrameworkComponent<ICellRendererParams> {
    public value: number;
    public width: string;
    public routerLink: any[];
    public queryParams: Params;
    public appendLink: boolean;

    public agInit(row: { value: BarParams }): void {
        const barParams = row.value;

        if (barParams) {
            this.routerLink = barParams.routerLink;
            this.queryParams = barParams.queryParams;
            this.appendLink = barParams.appendLink;

            this.value = barParams.value;
            const width = Math.round(100 * barParams.value / barParams.threshold);
            this.width = isNaN(width) ? '0' : width.toString() + '%';
        }
    }
}